import { capitalizeFirstLetter } from "../../../lib/helpers/capitalizeFirstLetter";

export const getAddonsName = (name: string, count: number) =>
  capitalizeFirstLetter(count <= 1 ? name : name + "s");
